
import { Vue, Component } from 'nuxt-property-decorator';
import { ErrorCode } from 'fourwaves-shared/components';

@Component({ components: { ErrorCode } })
export default class ErrorPage extends Vue {
  get errorCode() {
    return this.$route?.params.code || null;
  }

  get loginUrl() {
    return this.$route?.query.redirect ? (this.$route.query.redirect as string) : this.getLoginUrl();
  }
}
